import { render } from "./ReviewDemand.modal.vue?vue&type=template&id=1548e9c2"
import script from "./ReviewDemand.modal.vue?vue&type=script&lang=js"
export * from "./ReviewDemand.modal.vue?vue&type=script&lang=js"

import "./ReviewDemand.modal.vue?vue&type=style&index=0&id=1548e9c2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__